var _excluded = ["className", "light", "lighter", "role"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import PropTypes from "prop-types";
import React, { forwardRef } from "react";
import "./ADivider.scss";
var ADivider = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var propsClassName = _ref.className,
    light = _ref.light,
    lighter = _ref.lighter,
    _ref$role = _ref.role,
    role = _ref$role === void 0 ? "separator" : _ref$role,
    rest = _objectWithoutProperties(_ref, _excluded);
  var className = "a-divider";
  if (lighter) {
    className += " a-divider--color-lighter";
  } else if (light) {
    className += " a-divider--color-light";
  }
  if (propsClassName) {
    className += " ".concat(propsClassName);
  }
  return /*#__PURE__*/React.createElement("hr", _extends({}, rest, {
    role: role,
    ref: ref,
    className: className
  }));
});
ADivider.defaultProps = {
  role: "separator"
};
ADivider.propTypes = {
  /**
   * Toggles the light variant.
   */
  light: PropTypes.bool,
  /**
   * Toggles the lighter variant.
   */
  lighter: PropTypes.bool,
  /**
   * Sets the [WAI-ARIA](https://www.w3.org/WAI/standards-guidelines/aria/) role.
   */
  role: PropTypes.oneOf(["separator", "presentation"])
};
ADivider.displayName = "ADivider";
export default ADivider;